module.exports = __webpack_public_path__ + "img/icn_close.c0c9ecb4.svg";